export { Avatar, type AvatarProps } from './Avatar';
export { default } from './Avatar';



